// maintenanceConfig.js
export const maintenanceRoutes = [
    //'/reports',
    // Add other paths that are under maintenance
  ];
  